 import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import apiClient from '.';
import { AxiosRequestConfig } from 'axios';

interface UseGetDataProps<T> {
  queryKey: string | any[];
  url: string;
  params?: Record<string, any>;
  options?: UseQueryOptions<T, Error>;
}

export const useGetData = <T>({ queryKey, url, params, options }: UseGetDataProps<T>) => {
  return useQuery<T, Error>({
    queryKey: Array.isArray(queryKey) ? queryKey : [queryKey, params],
    queryFn: async () => {
      const config: AxiosRequestConfig = { params };
      const response = await apiClient.get<T>(url, config);
      return response.data;
    },
    ...options,
  });
};


// // src/hooks/useGetData.ts
// import { useQuery, UseQueryOptions } from "@tanstack/react-query";
// import { message } from "antd"; 
// import { AxiosRequestConfig, AxiosError } from "axios"; 
// import { extractErrorMessage } from "./ErrorHandler";
// import apiClient from ".";

// interface UseGetDataProps<T> {
//   queryKey: string | any[];
//   url: string;
//   params?: Record<string, any>;
//   options?: UseQueryOptions<T, AxiosError>;
// }

// export const useGetData = <T>({ queryKey, url, params, options }: UseGetDataProps<T>) => {
//   return useQuery<T, AxiosError>({
//     queryKey: Array.isArray(queryKey) ? queryKey : [queryKey, params],
//     queryFn: async () => {
//       const config: AxiosRequestConfig = { params };
//       const response = await apiClient.get<T>(url, config);
//       return response.data;
//     },
//     onError: (error) => {
//       const errorMessage = extractErrorMessage(error);
//       message.error(errorMessage); // Show the error message
//       if (options?.onError) options.onError(error); // Call custom onError if provided
//     },
//     ...options,
//   });
// };
